import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import toast, { Toaster } from "react-hot-toast";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import PreferencesNav from "./PreferencesNav";
import AddIcon from "@mui/icons-material/Add";

import { getTdsRecords, addTDS, editTDS } from "../../services/index";

const TDSList = () => {
  const [tdsInfo, setTdsInfo] = useState({});
  const [filteredData, setFilteredData] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setTdsInfo({});
    setShow(false);
  };

  useEffect(() => {
    getTdsList();
  }, []);

  const getTdsList = () => {
    var data = {
      page: 0,
      search: "",
      size: -1,
    };
    getTdsRecords(data).then((res) => {
      if (res.errorCode == 0) {
        var d = res.responsePacket.data;
        setFilteredData(d);
      } else {
        toast(res.message);
        return;
      }
    });
  };

  const columns = [
    {
      name: "Title",
      cell: (row) => row.title,
    },
    {
      name: "Rate",
      cell: (row) => row.rate,
    },
  ];

  const handleClicked = (row) => {
    setTdsInfo({
      ...tdsInfo,
      recordId: row?.recordId,
      title: row?.title,
      rate: row?.rate,
    });
    setShow(true);
  };

  const handleData = (e) => {
    setTdsInfo({
      ...tdsInfo,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = () => {
    if (!tdsInfo.rate) {
      toast("Please fill rate");
      return;
    }
    if (!tdsInfo.title) {
      toast("Please fill title");
      return;
    }

    const data = {
      rate: tdsInfo.rate,
      title: tdsInfo.title,
    };
    if (tdsInfo.recordId) {
      editTDS(tdsInfo.recordId, data).then((res) => {
        if (res.errorCode == 0) {
          toast.success(res.message);
          getTdsList();
          handleClose();
        } else {
          toast(res.message);
          return;
        }
      });
    } else {
      addTDS(data).then((res) => {
        if (res.errorCode == 0) {
          toast.success(res.message);
          getTdsList();
          handleClose();
        } else {
          toast(res.message);
          return;
        }
      });
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="sm">
        <Modal.Header>TDS Info</Modal.Header>
        <Modal.Body>
          <table>
            <tr>
              <td>Title:</td>
              <td>
                <input
                  autoComplete="off"
                  className=" form-control"
                  value={tdsInfo.title}
                  name="title"
                  onChange={(e) => handleData(e)}
                />
              </td>
            </tr>
            <tr>
              <td>Rate:</td>
              <td>
                <input
                  autoComplete="off"
                  className="form-control"
                  type="number"
                  name="rate"
                  value={tdsInfo.rate}
                  onChange={(e) => handleData(e)}
                />
              </td>
            </tr>
          </table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <div className="column list-column d-print-none column-small">
        <PreferencesNav />
      </div> */}
      <div className="column content-column">
        <div className="header clearfix" style={{ borderBottom: "none" }}>
          <span className="float-left" style={{ fontSize: "35px" }}>
            TDS List
          </span>
        </div>

        <div style={{ height: 500, width: "100%" }}>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            onRowClicked={(data) => {
              handleClicked(data);
            }}
            fixedHeader
            subHeader
            subHeaderComponent={
              <>
                <button
                  id="ember5839"
                  className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
                  type="button"
                  onClick={() => setShow(true)}
                >
                  <AddIcon />
                  New
                </button>
              </>
            }
          />
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default TDSList;
